import Splide from '@splidejs/splide';

new Splide( '#nav-cards', {
	type: "loop",
	padding: {
		left: 10,
		right: 10
	},
	perPage: 3,
	gap: 30,
	focus: "center",
	arrows: false,
	pagination: false,
	breakpoints: {
		1000: {
			fixedWidth: "17.5rem",
			pagination: true
		}
	}
} ).mount();

new Splide('#testimonial-cards', {
	type: "loop",
	interval: 8000,
	autoplay: true,
	padding: {
		left: 10,
		right: 10
	},
	perPage: 3,
	perMove: 2,
	gap: 30,
	focus: "center",
	breakpoints: {
		1280: {
			perPage: 2,
			perMove: 1
		},
		670: {
			perPage: 1
		}
	}
}).mount();